import React, { useState } from "react";
import { Link } from "react-router-dom";
import Header from "@/components/Header";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Mail, ArrowLeft, CheckCircle2 } from "lucide-react";

export default function ResetPasswordRequest() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/password-reset/request", { email });
      setSent(true);
    } catch (e) { toast.error(e.response?.data?.detail || "Erro"); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-neutral-50">
      <Header />
      <div className="max-w-md mx-auto px-4 sm:px-6 py-10 sm:py-16">
        <Link to="/login" className="inline-flex items-center gap-1.5 text-sm text-neutral-500 hover:text-neutral-900 mb-6"><ArrowLeft size={14}/> Voltar</Link>
        <div className="text-xs uppercase tracking-[0.25em] font-bold text-neutral-500 mb-3">Recuperação</div>
        <h1 className="font-heading font-black text-3xl sm:text-4xl tracking-tight">Esqueci minha senha</h1>

        {!sent ? (
          <>
            <p className="mt-3 text-sm text-neutral-600">Digite o e-mail vinculado à sua conta. Enviaremos um link de redefinição válido por 30 minutos.</p>
            <form onSubmit={submit} className="mt-8 space-y-4" data-testid="pwd-reset-request-form">
              <div>
                <Label>E-mail</Label>
                <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5 h-12" data-testid="reset-request-email" required />
              </div>
              <Button type="submit" disabled={loading} className="w-full h-12 rounded-md bg-neutral-900 hover:bg-neutral-800" data-testid="reset-request-submit">
                <Mail size={16} className="mr-1.5"/> {loading ? "Enviando…" : "Enviar link"}
              </Button>
            </form>
          </>
        ) : (
          <div className="mt-8 bg-white border border-neutral-200 rounded-2xl p-6 text-center" data-testid="pwd-reset-request-sent">
            <CheckCircle2 className="mx-auto text-green-600" size={40} />
            <div className="mt-4 font-heading font-black text-xl">Verifique seu e-mail</div>
            <p className="mt-2 text-sm text-neutral-600">Se <b>{email}</b> estiver cadastrado, o link de redefinição foi enviado. Confira sua caixa de entrada e o spam.</p>
            <Link to="/login" className="mt-6 inline-block text-sm underline font-semibold">Voltar para o login</Link>
          </div>
        )}
      </div>
    </div>
  );
}
